import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../messages';
import { Link } from '../../../../../router';
import Theme, { colors } from '../../../../../themes';

const { seeMore } = messages;

class InterlinkingBlock extends React.PureComponent {
  state = {
    more: false,
  };

  showMore = () => {
    this.setState({
      more: true,
    });
  };

  renderLinks = links => {
    const { more } = this.state;

    return links.map((link, index) => {
      const composedKey = `${link.path}-${index + 1}`;

      return (
        <Link key={composedKey} route={link.path}>
          <a className={index > 5 && !more ? 'hide' : null}>{link.text}</a>
        </Link>
      );
    });
  };

  render() {
    const { title, links, similar, dataTest } = this.props;
    const { more } = this.state;

    // TODO: remove the links.length part when API no longer send emtpy objects
    if (!links || links.length === 0) {
      return null;
    }

    return (
      <div className={similar ? 'similar' : 'links'} data-test={dataTest}>
        <h3>{title}</h3>

        {this.renderLinks(links)}

        {links.length > 6 && !more && (
          <a className="seeMore" onClick={this.showMore}>
            <FormattedMessage {...seeMore} />
            <span>&rsaquo;</span>
          </a>
        )}
        <style jsx>
          {`
            .links {
              padding: 15px 7px;
              text-align: center;
            }

            .links h3 {
              color: ${colors.grayDark};
              font-size: 0.875em; /* 14/16 */
              font-weight: bold;
              margin-bottom: 10px;
            }

            .links :global(a) {
              background-color: ${colors.grayExtraLight};
              color: ${colors.grayDark};
              border-radius: ${Theme.global.borderRadius};
              display: inline-block;
              font-size: 0.75em; /* 12/16 */
              padding: 3px 7px;
              margin: 3px;
            }

            .links .seeMore {
              color: ${colors.orange};
            }

            .similar {
              padding: 15px 0;
            }

            .similar h3 {
              color: ${colors.grayDark};
              font-size: 0.9375em; /* 15/16 */
              font-weight: bold;
              padding: 10px 15px;
            }

            .similar :global(a) {
              border-top: 1px solid ${colors.grayLight};
              color: ${colors.grayDark};
              display: block;
              font-size: 0.9375em; /* 15/16 */
              padding: 10px 15px;
            }

            .similar .seeMore {
              color: ${colors.orange};
              text-align: center;
            }

            .similar .seeMore span {
              transform: rotate(90deg);
              display: inline-block;
              position: relative;
              top: 2px;
              left: 5px;
            }

            .links :global(.hide),
            .similar :global(.hide) {
              display: none;
            }
          `}
        </style>
      </div>
    );
  }
}
InterlinkingBlock.defaultProps = {
  similar: false,
  title: null,
};

InterlinkingBlock.propTypes = {
  similar: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  links: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]).isRequired,
  dataTest: PropTypes.string.isRequired,
};

export default InterlinkingBlock;
export { InterlinkingBlock as PureInterlinkingBlock };



// WEBPACK FOOTER //
// ./app/Serp/components/Interlinking/shared/InterlinkingBlock/index.js